import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PortalHeading } from "./PortalLayout";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function ChangePassword() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const forced = user?.must_change_password;
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) { toast.error("The new passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setUser({ ...user, must_change_password: false });
      toast.success("Password updated");
      nav("/portal", { replace: true });
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="max-w-md">
      <PortalHeading title={forced ? "Choose your password" : "Change password"} />
      {forced && <p className="mb-5 rounded-lg bg-[#F86900]/10 border border-[#F86900]/40 px-4 py-3 text-sm text-[#B54708]" data-testid="password-forced-notice">
        You signed in with the temporary password we emailed you. Please choose your own password to continue.</p>}
      <form onSubmit={submit} className="rounded-2xl bg-white p-6 space-y-4" data-testid="change-password-form">
        <label className="block text-sm font-medium">{forced ? "Temporary password" : "Current password"}
          <Input type="password" required value={f.current} onChange={set("current")} className="mt-1" data-testid="change-password-current-input" /></label>
        <label className="block text-sm font-medium">New password (min 8 characters)
          <Input type="password" required minLength={8} value={f.next} onChange={set("next")} className="mt-1" data-testid="change-password-new-input" /></label>
        <label className="block text-sm font-medium">Confirm new password
          <Input type="password" required minLength={8} value={f.confirm} onChange={set("confirm")} className="mt-1" data-testid="change-password-confirm-input" /></label>
        <button disabled={busy} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#020165] text-white font-semibold py-3 disabled:opacity-60" data-testid="change-password-submit">
          <KeyRound className="h-4 w-4" />{busy ? "Saving…" : "Save password"}</button>
      </form>
    </div>
  );
}
